import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-non-trouvee',
    templateUrl: './page-non-trouvee.component.html',
    styleUrls: ['./page-non-trouvee.component.css'],
    standalone: false
})
export class PageNonTrouveeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
